export default __webpack_public_path__ + "static/media/STD_Plan_Brochure.6aaf3971.pdf";